import { useMemo } from "react";
import { useUpdateNeedMutation, type NeedDto, type NeedPatchDto } from "../../autogen/bff-api";
import { useApiErrorEditorConfig, useCreateEditor } from "../../common/editing/save-coordinator";
import { NeedViewBody } from "./NeedViewBody";

interface Props {
  needId: string;
  need: NeedDto;
  refetch: () => void;
}

export const NeedViewRoot = ({ needId, need, refetch }: Props) => {
  void refetch;
  const editorErrorConfig = useApiErrorEditorConfig();
  const [updateNeed] = useUpdateNeedMutation();

  const config = useMemo(
    () => ({
      initialState: need,
      save: async (fields: Partial<NeedPatchDto>): Promise<NeedDto> =>
        await updateNeed({ needId, needPatchDto: fields as NeedPatchDto }).unwrap(),
      ...editorErrorConfig,
    }),
    [need, needId, updateNeed, editorErrorConfig],
  );

  useCreateEditor<NeedDto, NeedPatchDto>(needId, config);

  return <NeedViewBody needId={needId} />;
};
